import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const ApprovedStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 68.7 18", ...rest } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            enableBackground="enable-background:new 0 0 141.8 18;"
            xmlSpace="preserve"
        >
            <g>
                <g transform="translate(-957 -10126)">
                    <path
                        fill="#6EEDB8"
                        fillRule="evenodd"
                        d="M67 0H1.7C.8 0 0 .9 0 2v14c0 1.1.8 2 1.7 2H67c1 0 1.7-.9 1.7-2V2c0-1.1-.8-2-1.7-2z"
                        transform="translate(957 10126)"
                    ></path>
                </g>
            </g>
            <g fill="#21006E">
                <path d="M9.2 11.1H5.9l-.6 1.7H3.7L7 4.5h1.1l3.3 8.4H9.8l-.6-1.8zm-.5-1.3l-1.1-3-1.1 3h2.2zM12.6 4.5h2.7c1.9 0 2.8.8 2.8 2.4 0 1.6-1 2.5-2.8 2.5h-1.2v3.5h-1.5V4.5zM15.2 8c1.1 0 1.5-.3 1.5-1.1s-.4-1.1-1.5-1.1h-1.1V8h1.1zM19.6 4.5h2.7c1.9 0 2.8.8 2.8 2.4 0 1.6-1 2.5-2.8 2.5h-1.2v3.5h-1.5V4.5zM22.2 8c1.1 0 1.5-.3 1.5-1.1s-.4-1.1-1.5-1.1h-1.1V8h1.1zM31.2 12.9l-2-3.5h-1.1v3.5h-1.5V4.5h2.7c2 0 2.8.9 2.8 2.4 0 1.2-.6 2-1.5 2.3l2.3 3.6h-1.7zm-2-4.9c1 0 1.5-.3 1.5-1.1s-.5-1.1-1.5-1.1h-1.1V8h1.1zM33.4 8.7c0-2.6 1.6-4.4 4-4.4s4 1.7 4 4.4c0 2.6-1.6 4.4-4 4.4-2.4-.1-4-1.8-4-4.4zm6.5 0c0-1.8-1-2.9-2.5-2.9s-2.5 1.1-2.5 2.9c0 1.8 1 2.9 2.5 2.9s2.5-1.1 2.5-2.9zM49.4 4.5l-3.3 8.4H45l-3.3-8.4h1.7l2.3 5.9 2.2-5.9h1.5zM50.6 4.5h5.6v1.4h-4.1v2h3.8v1.4h-3.8v2.2h4.1v1.4h-5.6V4.5zM57.9 4.5h2.4c2.8 0 4.4 1.5 4.4 4.2s-1.5 4.1-4.4 4.1h-2.4V4.5zm2.2 7c2.1 0 3-.8 3-2.8 0-1.9-.9-2.8-2.9-2.8h-.9v5.6h.8z"></path>
            </g>
        </svg>
    );
};
